<template>
  <div class="f-input">
    <div class="f-input-tip" v-if="tip">{{(isFocus || currentValue) ? tip : ''}}</div>
    <div class="f-input-wrap">
      <div class="f-input-box">
        <input @keydown.enter="enterHandler" v-if="type=='text'" :maxlength="maxlength" @input="inputHandle" v-model="currentValue" @focus="focusHandler" @blur="blurHandler" type="text" :placeholder="placeholder" class="f-input-txt" />
        <input @keydown.enter="enterHandler" v-if="type=='tel'" :maxlength="maxlength" @input="inputHandle" v-model="currentValue" @focus="focusHandler" @blur="blurHandler" type="tel" :placeholder="placeholder" class="f-input-txt" />
        <input @keydown.enter="enterHandler" v-if="type=='password'" :maxlength="maxlength" @input="inputHandle" v-model="currentValue" @focus="focusHandler" @blur="blurHandler" type="password" :placeholder="placeholder" class="f-input-txt" />
      </div>
      <i class="icon icon-clear" v-if="isShowDel" @click.stop="clear"></i>
      <slot>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: "text"
    },
    maxlength: {
      type: Number,
      default: -1
    },
    tip: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    showDel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShowDel: false,
      isFocus: false,
      currentValue: this.value || ''
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal != oldVal) {
        this.currentValue = newVal;
      }
    }
  },
  methods: {
    inputHandle() {
      if (this.showDel) {
        if (this.currentValue !== '') {
          this.isShowDel = true;
        } else {
          this.isShowDel = false;
        }
      }
      this.$emit('input', this.currentValue);
    },
    enterHandler(){
      this.$emit('enter', this.currentValue);
    },
    clear() {
      this.currentValue = '';
      this.isShowDel = false;
    },
    focusHandler() {
      this.isFocus = true;
      this.$emit('focus');
    },
    blurHandler() {
      this.isFocus = false;
      this.$emit('blur');
    }
  }
}

</script>
<style lang="less" scoped>
@import '~styles/mixin';
@import '~styles/var';
.f-input {
  .f-input-tip {
    height: 33px;
    line-height: 33px;
    color: #999;
  }
  .f-input-wrap {
    display: flex;
    align-items: center;
    .f-input-box {
      flex: 1;
      .f-input-txt {
        line-height: 30px;
        height: 30px;
        border: 0;
        width: 100%;
      }
    }
  }
}

</style>
